export default __webpack_public_path__ + "static/media/26.59a12c70.svg";